import { render, staticRenderFns } from "./KeepAliveRouter.vue?vue&type=template&id=51f1aa47&"
import script from "./KeepAliveRouter.vue?vue&type=script&lang=js&"
export * from "./KeepAliveRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports